var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGdriveLogo = function SvgGdriveLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gdriveLogo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066DA",
    d: "m2.614 20.545 1.184 2.044c.245.43.599.769 1.014 1.014q1.782-2.263 2.481-3.472.71-1.23 1.744-3.842-2.787-.367-4.225-.367-1.38 0-4.226.367c0 .476.123.953.369 1.383z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M23.189 23.603a2.8 2.8 0 0 0 1.014-1.014l.492-.845 2.351-4.072c.241-.421.368-.898.369-1.383q-2.863-.367-4.218-.367-1.457 0-4.218.367 1.022 2.627 1.72 3.842.705 1.224 2.49 3.472"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00832D",
    d: "M14 7.683q2.062-2.49 2.842-3.841.629-1.088 1.383-3.473A2.7 2.7 0 0 0 16.842 0h-5.686c-.491 0-.968.138-1.383.369q.96 2.736 1.63 3.894.739 1.28 2.596 3.42"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684FC",
    d: "M18.963 16.29H9.036l-4.225 7.314a2.7 2.7 0 0 0 1.382.368h15.613a2.86 2.86 0 0 0 1.383-.369z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00AC47",
    d: "M14 7.683 9.776.37a2.8 2.8 0 0 0-1.014 1.014L.955 14.906a2.8 2.8 0 0 0-.37 1.383h8.452z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA00",
    d: "M23.143 8.145 19.24 1.383A2.8 2.8 0 0 0 18.226.37L14 7.684l4.963 8.605H27.4c0-.477-.122-.953-.368-1.383z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gdriveLogo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.584 0h26.832v24H.584z"
  })))));
};
export default SvgGdriveLogo;